import { createSelector } from 'reselect';

const selectForumPosts = (state: any) => state.forumPosts;


export const selectForumPostsCurrentItem = createSelector([selectForumPosts], (forumPosts) => forumPosts.current);

export const selectForumPostsListItems = createSelector([selectForumPosts], (forumPosts) => forumPosts.list);

export const selectForumPostsItemById = (itemId: any) =>
    createSelector(selectForumPostsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectForumPostsQueryItems = createSelector([selectForumPosts], (forumPosts) => forumPosts.query);

export const selectForumPostsCreatedItem = createSelector([selectForumPosts], (forumPosts) => forumPosts.create);

export const selectForumPostsUpdatedItem = createSelector([selectForumPosts], (forumPosts) => forumPosts.update);

export const selectForumPostsReadItem = createSelector([selectForumPosts], (forumPosts) => forumPosts.read);

export const selectForumPostsDeletedItem = createSelector([selectForumPosts], (forumPosts) => forumPosts.delete);

export const selectForumPostsSearchedItems = createSelector([selectForumPosts], (forumPosts) => forumPosts.search);

export const selectForumPostsItemsCount = createSelector([selectForumPosts], (forumPosts) => forumPosts.count);

export const selectForumPostsItemsFilter = createSelector([selectForumPosts], (forumPosts) => forumPosts.filter);